import {filesize} from "filesize";

export const getSize = (size?: number) => {
    if (!size) {
        return null;
    }
    return filesize(size);
}